Namespace.create("cv.Views.Setup.Registration").TierView = Marionette.CompositeView.extend({
  template: cv.Templates["setup/registration/tier"],

  className: "tier",

  events: {
    click: "selectTier",
    "click .decrease-quantity": "decreaseQuantity",
    "click .increase-quantity": "increaseQuantity",
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    this.listenTo(
      this.model,
      "change:quantity",
      function () {
        this.$(".tier__quantity").text(this.model.get("quantity"));

        // Set toggles
        if (!this.options.enable_quantity) {
          // Hide quantity labels
          this.$(".increase-quantity, .decrease-quantity").css("visibility", "hidden");

          if (this.model.get("quantity") == 1) {
            this.$(".tier__controls-single").addClass("selected");
          } else {
            this.$(".tier__controls-single").removeClass("selected");
          }
        } else {
          // Show quantity labels
          this.$(".increase-quantity, .decrease-quantity").css("visibility", "visible");

          // Cap at 100
          if (this.model.get("quantity") >= 100) {
            this.$(".increase-quantity").css("visibility", "hidden");
          }

          if (this.model.get("quantity") == 0) {
            this.$(".decrease-quantity").css("visibility", "hidden");
          }
        }

        // Render the total
        this.triggerMethod("calculate_total");
      },
      this
    );

    console.log("TierView initialized");
  },

  templateHelpers: function () {
    return {
      amount: cv.formatMoney({
        show_sign: true,
        amount: this.model.get("amount"),
        currency_code: cv.campaign.get("currency_code"),
        decimal_places: 2,
      }),
    };
  },

  selectTier: function (e) {
    if (!this.options.enable_quantity) {
      e.preventDefault();

      // Reset the values
      this.triggerMethod("reset_tiers");

      // Set to 1
      this.model.set("quantity", 1);
    }
  },

  decreaseQuantity: function (e) {
    e.preventDefault();

    if (this.model.get("quantity") > 0) {
      this.model.set("quantity", this.model.get("quantity") - 1);
    }
  },

  increaseQuantity: function (e) {
    e.preventDefault();

    this.model.set("quantity", this.model.get("quantity") + 1);
  },

  onAttach: function () {
    // If we have not registered, set quantity to zero and remove any quantity selectors
    if (!this.options.has_registered) {
      if (this.model.collection.length == 1) {
        this.model.set("quantity", 1);
      } else {
        this.model.set("quantity", 0);
      }
    } else {
      this.$(".decrease-quantity, .increase-quantity").remove();
    }
  },
});
